<template>
  <main id="app">
    <section id="input">
      <table id="inputTable">
        <tr>
          <td class="weight">総重量(g)</td>
          <td><input id="weight" type="number" min="0" v-model="weight"></td>
        </tr>
        <tr v-if="minusPot">
          <td class="potWeight">鍋の重量(g)</td>
          <td>
            <input id="potWeight" type="number" min="0" v-model="potWeight">
            <button id="potWeightAddButton" type="button" class="text-button" v-on:click="savePotWeight">登録</button>
          </td>
        </tr>
        <tr>
          <td class="salinity-percent">全体の塩分濃度(%)</td>
          <td>
            <input id="salinityPercent" type="number" min="0" v-model="salinityPercent">
            <button id="percentAddButton" type="button" class="text-button" v-on:click="saveSalinityPercent">登録</button>
          </td>
        </tr>
      </table>
      <table id="salinityTable">
        <tr>
          <td id="salinityAmountLbl">目標塩分量(g)</td>
          <td id="salinityAmountVal">{{ salinity }}</td>
        </tr>
      </table>
    </section>

    <section id="select">
      <!--h3>調味料</h3-->
      <div id="seasoningList">
        <div>
          <select id="seasonings" v-model="selectedSeasonings" multiple size="5">
            <option v-for="seasoning in seasonings" v-bind:value="seasoning.key" :key="seasoning.key">
              {{ seasoning.name }}
            </option>
          </select>
        </div>

        <div>
          <button id="useButton" class="text-button" type="button" v-on:click="addUseList">この調味料を使う</button>
        </div>
      </div>
      <div id="editButton">
        <button id="addButton" type="button" v-on:click="addSeasoning"><img class="img-button" src="img/add.png" alt="追加" /></button>
        <button id="updateButton" type="button" v-on:click="updateSeasoning"><img class="img-button" src="img/update.png" alt="編集" /></button>
        <button id="deleteButton" type="button" v-on:click="deleteSeasoning"><img class="img-button" src="img/delete.png" alt="削除" /></button>
      </div>
      <div style="clear:both"></div>
    </section>

    <section id="use">
      <vue-slider ref="slider" v-model="dots" tooltip="none" :process="processFunc" :enable-cross="false">
        <template v-slot:process="{ start, end, style, index }">
          <div class="vue-slider-process" :style="style">
            <div :class="[
              'merge-tooltip',
              'vue-slider-dot-tooltip-inner',
              'vue-slider-dot-tooltip-inner-top',
            ]">
              {{ getRaito(index) }}
            </div>
          </div>
        </template>
      </vue-slider>
      <table style="table-layout:fixed;" v-if="useSeasonings.length > 0">
        <th class="seasoning">調味料</th>
        <th class="salinity-percent">塩分濃度</th>
        <th class="raito">比</th>
        <th class="amount">量</th>
        <th></th>
        <tr v-for="(seasoning, index) in useSeasonings" :key="seasoning.key">
          <td class="seasoning" v-bind:style="{ background:getColor(index) }">{{ seasoning.name}}</td>
          <td class="salinity-percent" v-bind:style="{ background:getColor(index) }">{{ seasoning.percent}}</td>
          <td class="raito" v-bind:style="{ background:getColor(index) }">{{ getRaito(index) }}</td>
          <td class="amount" v-bind:style="{ background:getColor(index) }">{{ getSalinityAmount(index, seasoning.percent) }}</td>
          <td><button id="deleteListButton" class="text-button" type="button" v-on:click="deleteUseList(seasoning.key)">削除</button></td>
        </tr>
      </table>
    </section>
    <MyModal v-if="showModal" id="modal">
      <table style="table-layout:fixed;">
        <th class="name">調味料</th>
        <th class="percent">塩分濃度(%)</th>
        <tr>
          <td class="name"><input id="seasoningName" type="text" v-model="seasoningName"></td>
          <td class="percent"><input id="seasoningPercent" type="number" min="0" v-model="seasoningPercent"></td>
        </tr>
      </table>
      <button id="registerButton" class="text-button" type="button" v-on:click="registerSeasoning">登録</button>
      <button id="cancelButton" class="text-button" type="button" v-on:click="cancel">キャンセル</button>
    </MyModal>

    <button id="settingButton" type="button" v-on:click="openSetting"><img class="img-button" src="img/setting.png" alt="オプション" /></button>
    <MyModal v-if="showSetting" id="settingModal">
      <section id="setting">
        <h3>オプション</h3>
        <div id="settingBody">
          <input id="chkMinusPot" type="checkbox" v-model="minusPot"><label for="chkMinusPot">鍋の重さを引く</label>
        </div>
        <div id="settingFooter">
          <button id="closeSettingButton" class="text-button" type="button" v-on:click="closeSetting">閉じる</button>
        </div>
      </section>
    </MyModal>
  </main>
</template>

<style>
  .merge-tooltip {
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translate(-50%, -15px);
  }
</style>

<script>
import MyModal from './components/MyModal.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  components: {
    MyModal,
    VueSlider
  },
  localStorage: {
    potWeight: {
      type: Number
    },
    salinityPercent: {
      type: Number
    },
    seasonings: {
      type: Object
    }
  },
  data: () => {
    return {
      weight: 0,
      seasonings: [],
      potWeight: 0,
      salinityPercent: 0,
      selectedSeasonings: [],
      useSeasonings: [],
      index: 0,
      seasoningKey: null,
      seasoningName: null,
      seasoningPercent: null,
      showModal: false,
      showSetting: false,
      minusPot: false,
      dots: [],
      color:["#00c4ffe6", "#7371f8", "#f57afdb5", "#f77373e8", "#f7b073e8"],
      processFunc: dotsPos => {
        var array = [];
        if (dotsPos.length < 1) {
          return array;
        }

        var color = ["#00c4ffe6", "#7371f8", "#f57afdb5", "#f77373e8", "#f7b073e8"];

        array[0] = [0, dotsPos[0], { backgroundColor : color[0]}];
        for (var i = 1; i < dotsPos.length; i++) {
          array[i] = [dotsPos[i - 1], dotsPos[i], { backgroundColor : color[i % 5]}];
        }
        array[dotsPos.length] = [dotsPos[dotsPos.length - 1], 100, { backgroundColor : color[dotsPos.length % 5], disabled:true}];
        return array;
      },
    }
  },
  computed: {
    salinity: function () {
      if (this.minusPot) {
        return ((Number(this.weight) < Number(this.potWeight) ? 0 : (this.weight - this.potWeight)) * this.salinityPercent / 100).toFixed(2);
      } else {
        return (this.weight * this.salinityPercent / 100).toFixed(2);
      }
    },
  },
  mounted: function() {
    var json = JSON.parse(this.$localStorage.get('seasonings'));
    
    if (json.length > 0) {
      this.seasonings = json.slice(0, json.length);
      this.index = 0;
    }
    var percent = this.$localStorage.get('salinityPercent');
    this.salinityPercent = !percent ? 0 : percent;

    var weight = this.$localStorage.get('potWeight');
    this.potWeight = !weight ? 0 : weight;

    this.minusPot = this.$localStorage.get('minusPot') === "true";
  },
  watch: {
    minusPot: function (newVal, oldVal) {
      this.$localStorage.set('minusPot', newVal);
    },
  },
  methods: {
    getColor: function (index) {
      return this.color[index % 5];
    },
    addSeasoning: function () {
      this.seasoningKey = null;
      this.seasoningName = null;
      this.seasoningPercent = null;
      this.showModal = true;
    },
    updateSeasoning: function () {
      if (this.selectedSeasonings.length > 0) {
        var seasoning = this.seasonings.filter((elm) => elm.key == this.selectedSeasonings[0]);
        this.seasoningKey = seasoning[0].key;
        this.seasoningName = seasoning[0].name;
        this.seasoningPercent = seasoning[0].percent;
        this.showModal = true;
      } else {
        // 選択なし
        alert("更新したい調味料を選択してください。");
      }
    },
    deleteSeasoning: function () {
      if(confirm("選択した調味料をメモリから削除してよろしいですか？")) {
        this.selectedSeasonings.forEach((elm) => {
          this.deleteSeasoningByKey(elm);
        })
        this.saveSeasonings();
        this.selectedSeasonings = [];
      }
    },
    deleteSeasoningByKey: function (key) {
      this.seasonings.forEach((elm, index) => {
        if (elm.key == key) {
          this.seasonings.splice(index, 1);
          return;
        }
      })
    },
    registerSeasoning: function () {
      if (!this.seasoningName) {
        alert("調味料名を入力してください");
        return;
      } else if (!this.seasoningPercent) {
        alert("塩分濃度を入力してください");
        return;
      }

      if (this.seasoningKey) {
        this.seasonings.forEach((elm) => {
          if (elm.key == this.seasoningKey) {
            elm.name = this.seasoningName;
            elm.percent = this.seasoningPercent;
            return;
          }
        });
      } else {
        this.seasonings.push({
          key : this.getUniqueStr(),
          name : this.seasoningName,
          percent : this.seasoningPercent
        });
      }
      this.saveSeasonings();
      this.showModal = false;
    },
    cancel: function () {
      this.showModal = false;
    },
    openSetting: function () {
      this.showSetting = true;
    },
    closeSetting: function () {
      this.showSetting = false;
    },
    addUseList: function () {
      if (this.selectedSeasonings.length > 0) {
        this.selectedSeasonings.forEach((key) => {
          if (this.useSeasonings.every(elm => elm.key != key)) {
            // 使用調味料に追加
            var value = this.seasonings.filter((elm) => {
              return elm.key == key;
            });
            this.useSeasonings.push(value[0]);

            this.setDots();
          }
        });
      } else {
        alert("使用したい調味料を選択してください。");
      }
    },
    deleteUseList: function(key) {
      this.useSeasonings.forEach((elm, index) => {
        if (elm.key == key) {
          this.useSeasonings.splice(index, 1);
          return;
        }
      });

      this.setDots();
    },
    setDots: function() {
      this.dots = [];
      if (this.useSeasonings.length > 1) {
        var x = 100 / this.useSeasonings.length;
        for (var i = 0; i < this.useSeasonings.length - 1; i++) {
          this.dots.push(Math.floor(x * (i + 1)));
        }
        this.$refs.slider.setValue(Array.from(this.dots));
      }
    },
    getRaito: function (index) {
      if (this.useSeasonings.length == 1) {
        return 100;
      } else if (index == 0) {
        // 調味料1つ目
        return Array.isArray(this.dots) ? this.dots[0] : this.dots;
      } else if (index == this.useSeasonings.length - 1) {
        // 調味料最後
        return 100 - (Array.isArray(this.dots) ? this.dots[index - 1] : this.dots);
      }

      // それ以外
      return this.dots[index] - this.dots[index - 1];
    },
    getSalinityAmount: function (index, percent) {
          return ((this.salinity * this.getRaito(index) / 100) / (percent / 100)).toFixed(1);
    },
    savePotWeight: function () {
      this.$localStorage.set('potWeight', this.potWeight);
      alert("鍋の重さ(" + this.potWeight + ")登録しました。");
    },
    saveSalinityPercent: function () {
      this.$localStorage.set('salinityPercent', this.salinityPercent);
      alert("塩分濃度(" + this.salinityPercent + "%)登録しました。");
    },
    saveSeasonings: function () {
      this.$localStorage.set('seasonings', JSON.stringify(this.seasonings));
    },
    getUniqueStr: function () {
      var strong = 1000;
      return new Date().getTime().toString(16) + Math.floor(strong*Math.random()).toString(16);
    },
  }
}
</script>